export const useDelayedExecute =
  () =>
  (callback, delay = 300) => {
    setTimeout(() => callback(), delay);
  };
